export default "__VITE_ASSET__BtSmiRdE__"